
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
// Import i18n configuration - must be before any components that use translations
import './i18n';

// Enhanced service worker registration for immediate offline support
if ('serviceWorker' in navigator) {
  console.log('Registering service worker for complete offline support...');
  navigator.serviceWorker.register('/service-worker.js', { 
    scope: '/',
    updateViaCache: 'none'
  })
    .then(registration => {
      console.log('ServiceWorker registered successfully:', registration.scope);
      
      // Handle updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('New service worker available');
              // Auto-update without user interaction
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        }
      });
    })
    .catch(error => {
      console.error('ServiceWorker registration failed:', error);
    });

  // Handle controller changes
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      console.log('Service worker updated, reloading...');
      window.location.reload();
    }
  });
}

// Simplify initialization without duplicate event listeners
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, initializing app state');
  
  // iOS specific handling - scroll to hide address bar
  if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
    setTimeout(() => {
      window.scrollTo(0, 1);
    }, 100);
  }
  
  // Set initial offline state safely
  try {
    if (!navigator.onLine) {
      console.log('Starting in offline mode');
      document.body.classList.add('offline');
    } else {
      console.log('Starting in online mode');
      document.body.classList.remove('offline');
    }
  } catch (error) {
    console.warn('Error checking initial network state:', error);
  }
});

// Safe React initialization
const initializeApp = () => {
  console.log('Initializing React app...');
  
  try {
    const rootElement = document.getElementById("root");
    if (!rootElement) {
      throw new Error('Root element not found');
    }

    // Ensure React is fully loaded
    if (typeof React === 'undefined' || !createRoot) {
      throw new Error('React not properly loaded');
    }

    const root = createRoot(rootElement);
    root.render(<App />);
    console.log('React app initialized successfully');
  } catch (error) {
    console.error('Failed to initialize React app:', error);
    // Show a basic error message
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="padding: 20px; text-align: center; font-family: Arial, sans-serif;">
          <h2>Application Error</h2>
          <p>The application failed to start. Please refresh the page.</p>
          <button onclick="window.location.reload()">Refresh</button>
        </div>
      `;
    }
  }
};

// Wait for both DOM and React to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp);
} else {
  // DOM already loaded
  setTimeout(initializeApp, 0);
}
